module.exports = __webpack_public_path__ + "img/check.a3b2fad1.svg";